
define('app/board/models/pickSummaryModel',[
	'jquery',
	'underscore',
	'backbone'
], function($, _, Backbone){
	var PickSummaryModel = Backbone.Model.extend({	
		defaults: {
			id: null, //Round * 1000 + posInRound
			round: null,
			posInRound: null,
			ovrPickNum: null,
			pickId: null,
			keeper: false,
			skipped: false,
			autoDrafted : false,
			playerPos: null,
			byeWeek: null,
			teamAbbr: null,
			fName: null,
			lName: null,
			fantasyTeamId : null,
			draftablePlayerId : null,
			auctionValue: null,
			auctionRound: null,
			auctionPosInRound: null
	    },

	    initialize: function() {
	    	
	    },
	    
	    /*clear: function() {
	    	this.set({pickId: null,
	    		keeper: false,
	    		playerPos: null,
	    		byeWeek: null,
	    		teamAbbr: null,
	    		fName: null,
	    		lName: null,
	    		fantasyTeamId : null,
	    		draftablePlayerId : null,
	    	}, {});
	    },*/
	    
	    clearKeepTeam: function() {
	    	this.set({pickId: null,
	    		keeper: false,
	    		skipped: false,
	    		autoDrafted : false,
	    		playerPos: null,
	    		byeWeek: null,
	    		teamAbbr: null,
	    		fName: null,
	    		lName: null,
	    		draftablePlayerId : null,
	    		auctionValue: null,
				auctionRound: null,
				auctionPosInRound: null
	    	}, {});
	    }
	});
	
	return PickSummaryModel;  
});